AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Utils");

// Contains miscellaneous shared functions.

AoPS.Alcumus.Utils = (function (AlcUtils) {
	var SpriteTable = AoPS.bootstrap_data.alc_sprite_table;

	// Used for displaying a quest badge given its ID, level, and whether it is an
	// achievement. Returns an object with keys path (image src), as well as xpos,
	// ypos for spriting. See the quest-badge template (used as a partial) for
	// how the data here is turned into HTML.
	AlcUtils.getBadgeData = function (quest_id, level, is_achievement) {
		var key = quest_id + "_" + level;
		var type = is_achievement ? "achievement" : "quest";
		var pos = AoPS.Utils.getKeyChain(SpriteTable, type, key) || [null, null];
		return {
			path: "/alcumus/images/" + type + "_badges_sprites_v2.png",
			xpos: pos[0],
			ypos: pos[1],
		};
	};

	return AlcUtils;
})(AoPS.Alcumus.Utils);
